'use strict';
import {getLogger} from 'loglevel';
var Backbone = require('backbone');

const log = getLogger('ProfileInformationView');

var ProfileInformationView = Backbone.View.extend({
  events: {
    'submit form': 'updateInfo'
  },
  parentValidator: null,
  initialize: function() {
    this.formValidator = this.$('form').validate({
      debug: true,
      rules: {
        FullName: {
          required: true
        },
        CompanyName: {
          required: true
        },
        PhoneNumber: {
          required: true
        }
      },
      messages: {
        FullName: 'Please enter your name',
        CompanyName: 'Please enter your company name',
        PhoneNumber: {
          required: 'Please provide a phone number',
          maxlength: 'Your phone number must be at least 5 characters long'
        }
      }
    });
  },
  updateInfo: function(e) {
    e.preventDefault();
    if (this.formValidator.valid()) {
      log.debug('Form valid!');
    } else {
      log.debug('Form invalid');
    }
  }
},{
  create: function($parent) {
    $parent.find('.ProfileInformation').each(function(n, el) {
      new ProfileInformationView({
        el: el
      });
    });
  }
});

module.exports = ProfileInformationView;



// WEBPACK FOOTER //
// ./assets/components/ProfileInformation/ProfileInformationView.js